import { firestore } from 'firebase';
import { MAXIMUM_STOCK } from 'src/constants/Notification';
import { formatDateToDate } from 'src/helpers/UtilityHelper';
import dayjs from 'dayjs';

/**
 * 入力値を上限数で切って返す
 */
export const roundMaximumQuantity = (num: number | null) => {
  let value: number;
  if (num === null) {
    value = 0;
  } else {
    value = num > MAXIMUM_STOCK ? MAXIMUM_STOCK : num;
  }
  return value;
};

/**
 * 削除可能なお知らせ時刻か（3分前までOK）
 */
export const isDeletableScheduledTime = (
  scheduledTime: Date | string | undefined | firestore.Timestamp,
) => dayjs(new Date()).add(3, 'minute').isBefore(formatDateToDate(scheduledTime));
